const RESULT_PRESENTATIONS = {
  failure: { icon: "status-critical", sentiment: "danger" },
  warning: { icon: "status-warning", sentiment: "warning" },
  inProgress: { icon: "status-in-progress", sentiment: "info" },
  partialSuccess: { icon: "clock", sentiment: "neutral" },
  success: { icon: "status-ok", sentiment: "success" },
  unknown: { icon: "info", sentiment: "neutral" },
};

const getCountEntries = (count) => {
  if (!count || typeof count !== "object" || Array.isArray(count)) return [];
  return Object.entries(count);
};

const normalize = (value) =>
  typeof value === "string" ? value.toLowerCase().replace(/_/g, "-") : "";

export const getTaskResult = (task = {}) => {
  if (!task || typeof task !== "object") task = {};
  const countEntries = getCountEntries(task.count);
  const countKeys = countEntries.map(([key]) => normalize(key));
  const taskStatus = normalize(task.status);
  const searchStatus = normalize(task.task_search_status);
  const hasValidationFailure = normalize(task.validation?.status).includes(
    "failure",
  );
  const hasPartialSuccess =
    taskStatus === "partial-success" ||
    searchStatus.includes("partial success");
  const hasFailure = countKeys.some((key) =>
    /failure|failed|time(?:d)?-?out/.test(key),
  );
  // vManage treats any unknown or "time out" count bucket as critical.
  const hasUnknownTimeoutCount = countKeys.some(
    (key) => key.includes("unknown") || key.includes("time out"),
  );
  const failedCountKeys = countKeys.filter((key) =>
    /failure|failed|time(?:d)?-?out/.test(key),
  );
  const hasInProgress = taskStatus === "in-progress";
  const hasTimeout =
    /time(?:d)?-?out/.test(taskStatus) || /time(?:d)?-?out/.test(searchStatus);
  const hasUnknown =
    taskStatus.includes("unknown") || searchStatus.includes("unknown");
  const hasSuccessCount = countKeys.some((key) => key.includes("success"));
  const hasTaskFailure = /failure|failed|error|cancel/.test(taskStatus);

  let resultType = "unknown";

  if (hasValidationFailure) {
    resultType = "failure";
  } else if (hasUnknownTimeoutCount) {
    resultType = "failure";
  } else if (
    countKeys.length > 0 &&
    failedCountKeys.length === countKeys.length
  ) {
    resultType = "failure";
  } else if (hasFailure && !hasPartialSuccess) {
    resultType = "warning";
  } else if (hasInProgress) {
    resultType = "inProgress";
  } else if (hasPartialSuccess) {
    resultType = "partialSuccess";
  } else if (hasTaskFailure || hasTimeout) {
    resultType = "failure";
  } else if (!hasUnknown && hasSuccessCount) {
    resultType = "success";
  }

  return {
    ...RESULT_PRESENTATIONS[resultType],
    resultType,
    countEntries,
  };
};

export default getTaskResult;
